import { render, staticRenderFns } from "./OpenTasks.vue?vue&type=template&id=66c5e2c0"
import script from "./OpenTasks.vue?vue&type=script&lang=js"
export * from "./OpenTasks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports